import { withInstall } from '@antdv/utils';
import ADivider from './src/Divider';

export const Divider = withInstall(ADivider);

export default Divider;

export * from './src/props';
